import axiosHttp from "./interceptor.service";

export const getTaskComments = (taskId, params = {}) =>
  axiosHttp.get(`/taskComments/${taskId}`, { params });

export const getTaskCommentCount = (taskId) =>
  axiosHttp.get(`/taskComments/${taskId}/count`);

export const createTaskComment = (taskId, payload) =>
  axiosHttp.post(`/taskComments/${taskId}`, payload);

export const updateTaskComment = (commentId, payload) =>
  axiosHttp.put(`/taskComments/${commentId}`, payload);

export const deleteTaskComment = (commentId) =>
  axiosHttp.delete(`/taskComments/${commentId}`);

export const reactToTaskComment = (commentId, type = "like") =>
  axiosHttp.post(`/taskComments/${commentId}/react`, { type });
